document.querySelectorAll('.header__nav-item--has-dropdown, .header__nav-item--mega').forEach((item) => {
  const trigger = item.querySelector(':scope > .header__nav-link, :scope > .header__mega-trigger');
  if (!trigger) return;

  const setExpanded = (expanded) => {
    trigger.setAttribute('aria-expanded', expanded);
  };

  item.addEventListener('mouseenter', () => setExpanded(true));
  item.addEventListener('mouseleave', () => setExpanded(false));
  item.addEventListener('focusin', () => setExpanded(true));
  item.addEventListener('focusout', (event) => {
    if (!item.contains(event.relatedTarget)) {
      setExpanded(false);
    }
  });
});

document.querySelectorAll('[data-mega-content][data-mode="image_per_link"]').forEach((content) => {
  const images = content.querySelectorAll('[data-hover-image]');
  if (images.length === 0) return;

  const showImage = (index) => {
    images.forEach((image, i) => {
      image.hidden = i !== index;
    });
  };

  showImage(0);

  const panel = content.closest('.header__mega-panel-inner');
  if (!panel) return;

  panel.querySelectorAll('[data-mega-link-index]').forEach((link) => {
    const index = parseInt(link.dataset.megaLinkIndex, 10);
    link.addEventListener('mouseenter', () => showImage(index));
    link.addEventListener('focus', () => showImage(index));
  });
});
